import { TTranslator } from '@smartshell/ui-kit';
import { render, unmountComponentAtNode } from 'react-dom';

import { TLocalesKeys } from 'localization';

import { ConfirmationModal } from './ConfirmationModal';
import { IConfig, TConfirmationType, TConfirmStatus } from './interfaces';

export const openConfirmDialog = (
  t: TTranslator<TLocalesKeys>,
  type: TConfirmationType,
  config?: Partial<IConfig>
): Promise<{ status: TConfirmStatus }> => {
  const modalRoot = document.getElementById('confirm-root');

  if (!modalRoot) {
    console.error(
      'node with id modal-root is not exist in document, check html file'
    );
    return Promise.reject();
  }

  const CONFIG_MAP: Record<TConfirmationType, IConfig> = {
    confirm: {
      title: t('notifyService.confirm.title'),
      acceptTitle: t('notifyService.confirm.accept'),
      declineTitle: t('notifyService.confirm.decline'),
      dialogData: [],
    },
    booking: {
      title: t('notifyService.confirm.title'),
      acceptTitle: t('notifyService.confirm.accept'),
      declineTitle: t('notifyService.confirm.decline'),
      dialogData: [],
    },
    remove: {
      title: t('notifyService.remove.title'),
      message: t('notifyService.remove.message'),
      acceptTitle: t('notifyService.remove.accept'),
      declineTitle: t('notifyService.remove.decline'),
      dialogData: [],
    },
    retry: {
      title: t('notifyService.retry.title'),
      message: t('notifyService.retry.message'),
      acceptTitle: t('notifyService.retry.accept'),
      dialogData: [],
    },
    notify: {
      title: t('notifyService.notify.title'),
      message: t('notifyService.notify.message'),
      acceptTitle: t('notifyService.notify.accept'),
      dialogData: [],
    },
  };

  const titles: IConfig = {
    ...CONFIG_MAP[type],
    ...config,
    dialogData: config?.dialogData ?? CONFIG_MAP[type].dialogData ?? [],
  };

  return new Promise((resolve) => {
    render(
      <ConfirmationModal
        type={type}
        config={titles}
        onAccept={() => {
          unmountComponentAtNode(modalRoot);
          resolve({ status: 'ACCEPTED' });
        }}
        onDecline={() => {
          unmountComponentAtNode(modalRoot);
          resolve({ status: 'DECLINED' });
        }}
      />,
      modalRoot
    );
  });
};
